import React from 'react';
import styled from 'styled-components';
import { palette } from '../../../../system/styles/styles';
import Delete from '../../../../system/access/images/ats/delete.png';
import _Save from '../../../../system/access/images/ats/save.png';
import { useTranslation } from 'react-i18next';

const ContainerMenu = styled.main`
  .Postulante {
    display: grid;
    grid-template-columns: calc(100% - 50px) 50px;
  }
  label {
    font-size: 16px;
    margin-left: 0px;
  }
  button {
    width: 50px;
    padding: 0px;
    cursor: pointer;
    justify-content: center;
    align-items: center;
  }
  img {
    width: 25px;
    height: 25px;
  }
  .items {
    display: flex;
    height: 50px;
    background-color: ${palette.blueBg};
    box-shadow: ${palette.BSnewCard};
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: #f2f2f2;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 6px;
    }
    overflow-x: auto;
  }
  .items button {
    margin: 0px;
    padding: 10px 20px;
    border: none;
    font-size: 16px;
    cursor: pointer;
    width: auto;
    border-radius: 0px;
    background-color: ${palette.blueBg};
    color: #ccc;
    transition: 0.3s;
    &:hover {
      border-bottom: solid 0.1px ${palette.black};
      color: ${palette.black};
      transition: 0.3s;
    }
    &:active {
      outline: none;
    }
    &:focus {
      outline: none;
    }
  }
  .selectBottom {
    border-bottom: solid 1px ${palette.black} !important;
    color: ${palette.black} !important;
  }
`;

const Menu = (props) => {
  const { names, lastNames, Save, typeUser, deleteCandidate, saveCandidate, indexModal, changedState } = props;
  const { t } = useTranslation(['applicant']);
  return (
    <ContainerMenu>
      {/*<div className="Postulante">*/}
      {/*  <label>{`${names} ${lastNames}`}</label>*/}
      {/*</div>*/}
      <div className="items">
        <button
          type="button"
          className={indexModal === 0 ? 'selectBottom' : ''}
          onClick={() => changedState('indexModal', 0)}>
          {t('GeneralMenu')}
        </button>
        <button
          type="button"
          className={indexModal === 1 ? 'selectBottom' : ''}
          onClick={() => changedState('indexModal', 1)}>
          {t('CommentsMenu')}
        </button>
        <button
          type="button"
          className={indexModal === 2 ? 'selectBottom' : ''}
          onClick={() => changedState('indexModal', 2)}>
          {t('ScoresMenu')}
        </button>

        <button
          type="button"
          className={indexModal === 3 ? 'selectBottom' : ''}
          onClick={() => changedState('indexModal', 3)}>
          {t('TransferMenu')}
        </button>
        <button
          type="button"
          className={indexModal === 4 ? 'selectBottom' : ''}
          onClick={() => changedState('indexModal', 4)}>
          {t('testingMenu')}
        </button>
      </div>
    </ContainerMenu>
  );
};

export default Menu;
